// Shared constants + formatters for the Budget Tutorial demos.
// Everything the tutorial renders comes from embedded data — ZERO network
// calls, so the page presents safely on any machine with no backend.

// The five FP&A forecast template tabs, exactly as named in the client's
// Tax Budget FY2026.xlsx workbook.
export const FPA_TABS = [
  'Outside Spend',
  'Travel',
  'Memberships & Dues',
  'Temp Labor',
  'All Other',
];

// P1 = February … P12 = January (Feb-start fiscal year).
export const PERIOD_LABELS = [
  'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul',
  'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan',
];

// "$15,500" / "−$4,000" — projector-sized money, whole dollars, true minus.
export function fmtUSD(n) {
  if (n == null) return '—';
  const abs = Math.abs(n).toLocaleString('en-US');
  return `${n < 0 ? '−' : ''}$${abs}`;
}

// Excel-style grid cell: thousands separators, parens for negatives,
// em dash for empty/zero (keeps the demo grid calm on a projector).
export function fmtCell(n) {
  if (n == null || n === 0) return '—';
  const abs = Math.abs(n).toLocaleString('en-US');
  return n < 0 ? `(${abs})` : abs;
}
